import {
  IonAccordion,
  IonAccordionGroup,
  IonContent,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonPage,
  IonToggle,
} from "@ionic/react";
import {
  business,
  call,
  cloud,
  diamond,
  logIn,
  logOut,
  mail,
  person,
  colorPalette,
  personCircle,
} from "ionicons/icons";
import HeaderComponent from "../components/HeaderComponent";

const aboutUsText =
  "Renon India is an advanced Lithium-ion battery pack manufacturer, with a superior 200 MWh production capacity based in Surat, Gujarat. Inspired by the government’s Make in India initiative, Renon India aims to be one of the largest manufacturers and battery technology experts across the globe.";

const Settings: React.FC = () => {
  const toggleTheme = (e: any) => {
    // console.log("toggleTheme event: ", e);
    if (e) {
      document.body.setAttribute("color-theme", "dark");
    } else {
      document.body.setAttribute("color-theme", "light");
    }
  };

  return (
    <IonContent fullscreen>
      <HeaderComponent title={"Settings"} />
      <IonAccordionGroup>
        <IonAccordion>
          <IonItem slot="header">
            <IonIcon icon={colorPalette} slot="start" />
            <IonLabel>Default Theme</IonLabel>
          </IonItem>
          <IonItem slot="content">
            <IonLabel>Dark Mode</IonLabel>
            <IonToggle onIonChange={(e) => toggleTheme(e.detail.checked)} />
          </IonItem>
        </IonAccordion>
        <IonAccordion>
          <IonItem slot="header">
            <IonIcon icon={cloud} slot="start" />
            <IonLabel>Upload to Cloud</IonLabel>
          </IonItem>
          <IonItem slot="content">
            <IonLabel>Unauthorized access</IonLabel>
            <IonToggle checked color="warning" disabled />
          </IonItem>
        </IonAccordion>
        <IonAccordion>
          <IonItem slot="header">
            <IonIcon icon={person} slot="start" />
            <IonLabel>Change password</IonLabel>
          </IonItem>
          <IonItem slot="content">
            <IonLabel>Unauthorized access</IonLabel>
          </IonItem>
        </IonAccordion>
        {/* <IonItem>
              <IonIcon icon={logOut} slot="start"/>
              <IonLabel>Log out</IonLabel>
            </IonItem> */}
        <IonAccordion>
          <IonItem slot="header">
            <IonIcon icon={diamond} slot="start" />
            <IonLabel>Version</IonLabel>
          </IonItem>
          <IonItem slot="content">
            <IonLabel>0.7.2-beta</IonLabel>
          </IonItem>
        </IonAccordion>

        <IonAccordion>
          <IonItem slot="header">
            <IonIcon icon={business} slot="start" />
            <IonLabel>About us</IonLabel>
          </IonItem>
          <IonItem slot="content">
            <p>{aboutUsText}</p>
          </IonItem>
          <IonItem slot="content">
            <a href="https://renon.in">Know more</a>
          </IonItem>
        </IonAccordion>

        <IonAccordion>
          <IonItem slot="header">
            <IonIcon icon={personCircle} slot="start" />
            <IonLabel>Customer care</IonLabel>
          </IonItem>
          <IonList slot="content">
            <IonItem>
              <IonIcon icon={mail} slot="start" />
              <IonLabel>sales@renonindia.in</IonLabel>
            </IonItem>
            <IonItem>
              <IonIcon icon={call} slot="start" />
              <IonLabel>+91-9099486000 | +91-6357193822</IonLabel>
            </IonItem>
          </IonList>
        </IonAccordion>
      </IonAccordionGroup>
    </IonContent>
  );
};

export default Settings;
